document.addEventListener("DOMContentLoaded", () => {
    const thumbnails = document.querySelectorAll('.thumbnail'); // Thumbnail images
    const navbarItems = document.querySelectorAll('.navbar-item'); // Navbar items
    const centerImages = document.querySelectorAll('.center-image'); // Center images

    if (!thumbnails.length || !navbarItems.length || !centerImages.length) {
      console.error('Thumbnails, Navbar items, or center images are missing in the DOM.');
      return;
    }

    // Intersection Observer to track visible center images
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const activeThumbId = entry.target.dataset.thumb; // Active thumbnail ID
          const activeNavId = entry.target.dataset.nav; // Active navbar item ID

          // Activate corresponding thumbnail
          const activeThumbnail = document.getElementById(activeThumbId);
          if (activeThumbnail) {
            thumbnails.forEach(thumb => {
              // Ensure opacity-50 is removed and opacity-100 is added only to the active thumbnail
              thumb.classList.remove('opacity-100'); // Remove active opacity class
              thumb.classList.add('opacity-50'); // Add default opacity class
            });
            activeThumbnail.classList.remove('opacity-50'); // Add active opacity class
            activeThumbnail.classList.add('opacity-100'); // Add active opacity class
          } else {
            console.error(`Thumbnail with ID "${activeThumbId}" not found.`);
          }

          // Activate corresponding navbar item
          const activeNavbarItem = document.getElementById(activeNavId);
          if (activeNavbarItem) {
            navbarItems.forEach(nav => nav.classList.remove('font-bold'));
            activeNavbarItem.classList.add('font-bold');
          } else {
            console.error(`Navbar item with ID "${activeNavId}" not found.`);
          }
        }
      });
    }, { threshold: 0.6 }); // 60% of the image is visible

    // Observe all center images
    centerImages.forEach(image => observer.observe(image));
  });